import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { TableRow } from "src/app/components/docs-list/docs-list.component";
import { DocumentInfo } from "src/app/models/document-info.model";

import { DocumentInfoListResult } from "../../models/document-info-list-result.model";
import { Filter } from "../../models/filter.model";
import { DocumentsService } from "../../services/documents.service";

@Component({
  templateUrl: "./product-docs.component.html",
  styleUrls: ["./product-docs.component.scss"],
})
export class ProductDocsPage implements OnInit {
  referer: string | undefined;
  title: string | undefined;
  list: DocumentInfoListResult | null = null;
  filteredList: DocumentInfo[] | null = null;
  rows: TableRow[] = [];
  filteredRows: TableRow[] = [];
  filters: Filter[] = [];
  selectedIds: string[] = [];
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private docService: DocumentsService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.referer = params["referer"];
      this.title = params["title"];
    });

    if (this.translateService.currentLang) {
      this.loadData();
    }

    this.translateService.onLangChange.subscribe(() => {
      this.loadData();
    });
  }

  loadData() {
    this.loading = true;
    const productId = this.getProductId();
    if (productId) {
      this.list = null;
      this.filters = [];
      this.docService
        .getDocumentsForProduct(productId)
        .then((list) => {
          this.list = list;
          this.rows = this.listToRows(list.items);

          this.calculateFilteredList();
          this.loading = false;
        })
        .catch((reason: HttpErrorResponse) => {
          let referer =
            "/" + this.route.snapshot.url.toString() + window.location.search;
          referer = encodeURIComponent(referer);
          if (reason.status === 403) {
            this.router.navigateByUrl(`/access-denied`);
          } else {
            this.router.navigateByUrl(`/error?referer=${referer}`);
          }
        });
    }
  }

  private getProductId(): string {
    return this.route.snapshot.params["productId"];
  }

  getSerialNumber(): string {
    return this.getProductId().split(":")[0];
  }

  private listToRows(list: DocumentInfo[]) {
    return (list || []).map((doc) => new TableRow(doc));
  }

  onRowSelection(ids: string[]) {
    this.selectedIds = ids;
  }

  onFilterChanged(appliedFilters: Filter[]) {
    this.filters = appliedFilters;
    this.calculateFilteredList();
  }

  navigateBack(referer: string) {
    this.router.navigateByUrl(referer);
  }

  calculateFilteredList() {
    this.filteredList = this.list!.items;
    for (const filter of this.filters) {
      if (filter.fieldName == "category") {
        this.filteredList = this.filteredList.filter((x) =>
          filter.selectedValues.includes(x.category),
        );
      }
      if (filter.fieldName == "documentType") {
        this.filteredList = this.filteredList.filter((x) =>
          filter.selectedValues.includes(x.documentType),
        );
      }
      if (filter.fieldName == "language") {
        this.filteredList = this.filteredList.filter((x) =>
          x.languagesHumanReadable.some((lang) =>
            filter.selectedValues.includes(lang),
          ),
        );
      }
      if (filter.fieldName == "includedLmid") {
        this.filteredList = this.filteredList.filter((x) =>
          filter.selectedValues.includes(x.includedLmid),
        );
      }
    }
    this.filteredRows = this.listToRows(this.filteredList);
  }
}
